// 복습(재시험)을 만들 수 있는 문제지 유형.
// **판정은 서버가 한다.** `api/utils/assignment/wrong_answer.py` 의 같은 이름 상수가
// 정본이고, 여기 있는 것은 버튼을 보여 줄지 정하는 화면용 사본이다. 한쪽을 고치면
// 다른 쪽도 고칠 것.
//
// 예전에는 화면에만 `["vocabulary", "paragraph"]` 가 박혀 있어서, 서버는 되는데
// 내용이해·지문분석 과제에는 복습 버튼이 아예 그려지지 않았다
// (2026-09 김윤경 학원 신고 4건).
export const RETRY_SUPPORTED_TYPE_LIST = [
  "vocabulary",
  "paragraph",
  "grammar",
  "sentence",
  "comprehensive",
  "analysis",
  "bank",
];

// 출제 payload 에 섹션을 만들 재료가 하나라도 들어 있는지 본다.
// 지인에듀가 200 을 주면서 빈 본문을 돌려주면 지문 껍데기만 남은 payload 가 만들어지고,
// 그대로 출제하면 학생이 풀 수 없는 과제가 된다.
// api/assignment/views.py 의 has_section_source_data 와 같은 판정이다.
export const hasSectionSourceData = (paragraphs) => {
  if (!paragraphs) return false;

  // sentence, grammar 는 지문 배열이 아니라 documents 를 담은 객체다.
  if (!Array.isArray(paragraphs)) {
    return (
      (paragraphs.documents?.length ?? 0) > 0 ||
      (paragraphs.sentence_list?.length ?? 0) > 0
    );
  }

  return paragraphs.some((paragraph) => (paragraph?.data?.length ?? 0) > 0);
};

export const getRandom5Sentences = (sentences) => {
  if (sentences.length <= 5) {
    return sentences; // 5개 이하일 경우 전체 리스트 반환
  }

  const startIndex = Math.floor(Math.random() * (sentences.length - 4));
  return sentences.slice(startIndex, startIndex + 5);
};
